import { render, staticRenderFns } from "./SlideSelect.vue?vue&type=template&id=4f8b8a19&lang=pug"
import script from "./SlideSelect.vue?vue&type=script&lang=ts"
export * from "./SlideSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports